import { render, staticRenderFns } from "./createStore.vue?vue&type=template&id=45975e24&scoped=true&"
import script from "./createStore.vue?vue&type=script&lang=js&"
export * from "./createStore.vue?vue&type=script&lang=js&"
import style0 from "./createStore.vue?vue&type=style&index=0&id=45975e24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45975e24",
  null
  
)

export default component.exports